/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


export interface UserDto {
    id: number;
    email: string;
    type: UserDto.type;
    blockchainAccountId: number;
    emailVerified: boolean;
    dni?: string;
    phone?: string;
    name: string;
    last_name?: string;
    full_name?: string;
    country?: string;
    address?: string;
    city?: string;
    postCode?: string;
    citizenship?: string;
    date_of_birth?: string;
    blocked: boolean;
    prove_of_address?: string;
    prove_of_identity?: string;
    company_and_news_updates: boolean;
    emergency_notifications: boolean;
    notifications_of_transfer: boolean;
    favorite_notifications: boolean;
    is_verified: boolean;
    credits: number;
    wallet_address?: string;
}

export namespace UserDto {

    export enum type {
        ARTIST = 'artist',
        COLLECTOR = 'collector',
        ADMIN = 'admin',
    }


}



// WEBPACK FOOTER //
// ./src/services/openapi/generated/models/UserDto.ts